import script from "./OfCreateBusinessPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OfCreateBusinessPayment.vue?vue&type=script&setup=true&lang=js"

import "./OfCreateBusinessPayment.vue?vue&type=style&index=0&id=35234488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35234488"]])

export default __exports__